import * as React from 'react'
import I18n from '../../../../core/i18n'
import { adminService } from '../../../../core/services'
import { InputText } from '../../../atoms'
import AdminLayoutNew from '../_layouts/new'
import * as interfaces from '../../../../static/interfaces'

declare var window: interfaces.IWindow

const FIELDS = {
  name: 'name',
  name_ja: 'name_ja',
  position: 'position',
}

const title = I18n.t('admin.create_new', {
  model: I18n.t('category', { scope: 'activerecord.models' }),
})

const AdminCategoryNew: React.FC<{}> = props => {
  const handleSubmit = React.useCallback(async (initialValues, values) => {
    const { createdCategory, flush } = await adminService.createCategory(values)
    window.flashMessages.addMessage({ text: flush.message, type: flush.type })
    location.href = '/admin/categories'
  }, [])

  return (
    <AdminLayoutNew
      model="category"
      title={title}
      fields={FIELDS}
      indexLink="/admin/categories"
      formItems={
        <>
          <InputText required={true} name="name" defaultValue="" label={I18n.t('generic.name')} />
          <InputText
            required={false}
            name="name_ja"
            defaultValue=""
            label={I18n.t('generic.name_ja')}
          />
          <InputText
            required={true}
            name="position"
            defaultValue=""
            label={I18n.t('generic.position')}
          />
        </>
      }
      handleSubmit={handleSubmit}
    />
  )
}

export default AdminCategoryNew
